document.addEventListener("DOMContentLoaded", async () => {
  const getAllProducts = async () => {
    const getProducts = async (page = 1, retryCount = 0) => {
      try {
        const allProducts = await fetch(`/collections/all?view=data&page=${page}`);
        
        if (allProducts.status === 429) {
          // Rate limited - wait and retry
          const delay = Math.min(1000 * Math.pow(2, retryCount), 10000); // Exponential backoff, max 10s
          console.log(`Rate limited on page ${page}, retrying in ${delay}ms`);
          await new Promise(resolve => setTimeout(resolve, delay));
          return getProducts(page, retryCount + 1);
        }
        
        if (!allProducts.ok) {
          throw new Error(`HTTP error! status: ${allProducts.status}`);
        }
        
        const allProductText = await allProducts.text();
        const allProductData = JSON.parse(allProductText);
        return allProductData;
      } catch (error) {
        if (retryCount < 3) {
          const delay = Math.min(1000 * Math.pow(2, retryCount), 5000);
          console.log(`Error fetching page ${page}, retrying in ${delay}ms:`, error);
          await new Promise(resolve => setTimeout(resolve, delay));
          return getProducts(page, retryCount + 1);
        }
        throw error;
      }
    };

    const allProducts = await getProducts();

    const totalPages = Math.ceil(allProducts.count / 250);
    for (let i = 2; i <= totalPages; i++) {
      // Add delay between requests to avoid rate limiting
      await new Promise(resolve => setTimeout(resolve, 100)); // 100ms delay
      const products = await getProducts(i);
      allProducts.products.push(...products.products);
    }

    sessionStorage.setItem("allProducts", JSON.stringify(allProducts));

    publish(PUB_SUB_EVENTS.allProductsLoaded);
  };

  const products = sessionStorage.getItem("allProducts");

  if (products) {
    publish(PUB_SUB_EVENTS.allProductsLoaded);

    const parsedProducts = JSON.parse(products);
    const timestamp = parsedProducts.timestamp;
    // API timestamp is in seconds; normalize to ms for comparison
    const timestampMs =
      typeof timestamp === "number"
        ? timestamp < 1e12
          ? timestamp * 1000
          : timestamp
        : 0;

    // if timestamp is older than 5 minutes, reload the products
    if (!timestampMs || timestampMs < Date.now() - 1000 * 60 * 5) {
      await getAllProducts();
      return;
    }
  } else {
    getAllProducts();
  }
});